import { AlertColor } from '@mui/material/Alert'

const ERROR_KEYWORDS = ['未成交', '無法', '失敗', '未成功']
const PASS_KEYWORD = ['成交', '成功']
export const tellTheMessageLevel = (message: string): AlertColor => {
  if (ERROR_KEYWORDS.some(word => message.includes(word))) return 'error'
  if (PASS_KEYWORD.some(word => message.includes(word))) return 'success'
  return 'warning'
}
